import React, { useRef, useEffect, useState } from "react";
import DisplayHelper from './DisplayHelper';
interface iEnergipresentationAccordion {
    title: string;
    text: string;
    table: string;
    modelStyle?: string | "";
}

const EnergipresentationAccordion = (props: iEnergipresentationAccordion) => {
    const idRef = useRef(
        `collapseItem-${Math.random().toString(36).substr(2, 9)}`
    );
    const collapseId = idRef.current;

    const bodyRef = useRef<HTMLDivElement>(null);
    const [tableHasScroll, setTableHasScroll] = useState(false);

    const checkScroll = () => {
        const body = bodyRef.current;
        if (!body) return;

        const tables = body.querySelectorAll("table");
        let hasScroll = false;

        tables.forEach((table) => {
            const scrollContainer = table.closest(
                ".scroll-container"
            ) as HTMLElement | null;
            if (!scrollContainer) return;

            const horizontal = table.scrollWidth > scrollContainer.clientWidth;
            const vertical = table.scrollHeight > scrollContainer.clientHeight;

            if (horizontal || vertical) {
                hasScroll = true;
            }
        });

        setTableHasScroll(hasScroll);
    };

    useEffect(() => {
        checkScroll();

        window.addEventListener("resize", checkScroll);

        const body = bodyRef.current;
        const mutationObs = new MutationObserver(() => checkScroll());
        if (body) {
            mutationObs.observe(body, { childList: true, subtree: true });
        }

        const timeoutId = setTimeout(checkScroll, 200);

        return () => {
            window.removeEventListener("resize", checkScroll);
            mutationObs.disconnect();
            clearTimeout(timeoutId);
        };
    }, [props.table]);

    return (
        <div
            className={
                "Block expandable-block energipresentation-accordion " +
                (props.modelStyle || "")
            }
        >
            <button
                className="accordion-title"
                data-toggle="collapse"
                data-target={`#${collapseId}`}
                aria-controls={collapseId}
                aria-expanded="false"
                onClick={() => {
                    checkScroll();
                    setTimeout(checkScroll, 1);
                }}
            >
                {props.title}
                <img
                    className="arrow-down"
                    src="/Static/img/icons8-chevron-down-20.PNG"
                    alt=""
                />
            </button>

            <div className="accordion-content collapse" id={collapseId}>
                <div
                    className="bodytext is-block"
                    dangerouslySetInnerHTML={{ __html: props.text }}
                />
                {tableHasScroll && (
                    <div className="table-helper-text">{DisplayHelper.LocaleText('The table is wider than the screen - scroll right for more information.', 'Tabellen är bredare än skärmen - scrolla åt höger för mer information.')}</div>
                )}
                <div
                    ref={bodyRef}
                    className="bodytext is-block"
                    dangerouslySetInnerHTML={{ __html: props.table }}
                />
            </div>
        </div>
    );
};

export default EnergipresentationAccordion;
